import { createPortal } from "react-dom";
import useSWR from "swr";
import { X } from "lucide-react";
import { api, ago, fetcher } from "@/lib/api";

const LEVEL = { success: "border-l-[#0ecb81]", error: "border-l-[#f6465d]", warning: "border-l-[#fcd535]", info: "border-l-[#3b82f6]" };

export function NotificationsDrawer({ open, onClose }) {
  const { data, mutate } = useSWR(open ? "/notifications?limit=50" : null, fetcher);
  if (!open) return null;
  const markAll = async () => { await api.post("/notifications/read-all"); mutate(); };
  return createPortal(
    <div className="fixed inset-0 z-[100]" data-testid="notifications-drawer">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <aside className="absolute right-0 top-0 h-full w-full sm:w-[380px] bg-[#181a20] border-l border-[#2b3139] flex flex-col fade-in">
        <div className="h-14 px-4 flex items-center justify-between border-b border-[#2b3139]">
          <div><div className="font-semibold text-white">Notifications</div><div className="text-[11px] text-[#848e9c]">{data?.unread || 0} unread</div></div>
          <div className="flex items-center gap-2">
            <button onClick={markAll} className="btn-ghost rounded px-2 h-7 text-[11px]" data-testid="notifications-mark-all-read">Mark all read</button>
            <button onClick={onClose} className="text-[#848e9c] hover:text-white" data-testid="notifications-close"><X size={16} /></button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto p-2 space-y-1.5">
          {(data?.items || []).length === 0 && <div className="text-center text-[#5e6673] text-xs py-10">No notifications yet</div>}
          {(data?.items || []).map((n) => (
            <div key={n.id} className={`bg-[#1e2329] border border-[#2b3139] border-l-2 ${LEVEL[n.level] || LEVEL.info} rounded px-3 py-2 ${n.read ? "opacity-60" : ""}`} data-testid="notification-item">
              <div className="flex items-center justify-between"><span className="text-xs font-semibold text-white">{n.title}</span><span className="text-[10px] text-[#5e6673] mono">{ago(n.created_at)}</span></div>
              <div className="text-[12px] text-[#848e9c] mt-0.5">{n.message}</div>
            </div>
          ))}
        </div>
      </aside>
    </div>,
    document.body
  );
}
